
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/RoomLog/List', formData);
}


const GetStatisticalLog = async (formData: FormData) => {
    return AxiosHelper.post('/RoomLog/GetStatisticalLog', formData);
}


const RoomLogService = {
    List,
    GetStatisticalLog
}

export default RoomLogService;